import React from 'react';
import TextField from '@material-ui/core/TextField';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import * as RegistrationConstants from './RegistrationConstants';

export default function EmailVerificationForm(props) {
    const [values, setValues] = React.useState({
        verificationCode: props.verCode !== '' ? props.verCode : ''
    });

    // Method to set field values on change
    const handleChanges = name => event => {
        props.handleVerificationCodeChange(event.target.value);
        setValues({ ...values, [name]: event.target.value.replace(AppConstants.NUMBER_ONLY_REGEX, '') });
    };

    return (
        <div className="">
            <form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
            <div className="mui-custom-form col px-2 m-0 mb-3">
                <TextField
                    required
                    id="standard-verficationCode"
                    placeholder="Enter Here"
                    label={RegistrationConstants.VERIFICATION_CODE}
                    value={values.verificationCode}
                    inputProps={{ maxLength: 6 }}
                    onChange={handleChanges('verificationCode')}
                    InputLabelProps={{
                        shrink: true
                    }}
                    error={props.verificationCodeError}
                    helperText={props.verificationCodeError ? props.verificationCodeErrorText : null}
                />
            </div>
            </form>
        </div>
    )
}
